import { USState, USStateAbbreviated } from "../../../../../../lib/types"

export interface MinimumWageTableI {
    state: USStateAbbreviated
    city: string | null
    minimum_wage: string | number
    effective_date: string | Date
}

export interface MinimumWageModalFormI extends MinimumWageTableI {
    showCal: boolean
}

export interface MinimumWageStateI {
    rows: MinimumWageTableI[]
        selectedRow?: MinimumWageTableI
        filteredState: USState | 'All States'
        requestPending: boolean
        dbUpdated: boolean
        modal: {
            open: boolean
            name?: 'ADD_WAGE' | 'EDIT_WAGE' | 'DELETE_WAGE'
            form: MinimumWageModalFormI
        }
}

export const initialFormState: MinimumWageModalFormI = {
    state: 'AL',
    city: '',
    minimum_wage: '',
    effective_date: new Date(),
    showCal: false
}

export const initialState: MinimumWageStateI = {
    rows: [],
    selectedRow: undefined,
    filteredState: 'All States',
    requestPending: false,
    dbUpdated: false,
    modal: {
        open: false,
        name: undefined,
        form: initialFormState
    },
}

